<template>
  <div class="page page_fortune">
    <div class="page_fortune__inner">
      <h1 class="page_fortune__title">Скидки для клиентов</h1>

      <p class="page_fortune__subtitle">
        <template v-if="!savedDiscount">Получите скидку прямо сейчас — просто прокрутите колесо!</template>
        <br><span class="page_fortune__subtitle-bold">Скидка определяется случайным образом на колесе:</span><br>100, 200, 300, 400 или 500 рублей, либо от 1 до 10% от суммы заказа.
      </p>

      <div v-if="savedDiscount" class="page_fortune__already">
        <div class="page_fortune__already-logo">
          <img src="/logo.png" alt="" class="page_fortune__already-logo-img" />
        </div>
        <p class="page_fortune__already-text">Вы уже крутили колесо</p>
        <p class="page_fortune__already-value">{{ savedDiscount }}</p>
        <p class="page_fortune__already-hint">Предъявите скидку при заказе</p>
      </div>

      <div v-else class="page_fortune__card">
        <div class="page_fortune__wheel-block">
          <FortuneWheel
            v-if="items.length"
            :items="items"
            @finished="onWheelFinished"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FortuneWheel from '@/components/fortune/FortuneWheel.vue'
import { getApiUrl } from '@/config/api'

const FORTUNE_STORAGE_KEY = 'fort'

export default {
  name: 'Fortune',
  components: { FortuneWheel },
  data() {
    return {
      items: [],
      savedDiscount: null,
    }
  },
  async created() {
    const saved = localStorage.getItem(FORTUNE_STORAGE_KEY)
    if (saved) this.savedDiscount = saved

    try {
      const res = await fetch(getApiUrl('/fortune'))
      const json = await res.json()
      this.items = Array.isArray(json.items) ? json.items : []
    } catch (e) {
      console.error('Failed to load fortune items', e)
    }
  },
  methods: {
    async onWheelFinished(label) {
      if (!label) return
      try {
        localStorage.setItem(FORTUNE_STORAGE_KEY, label)
      } catch (e) {}
      try {
        await fetch(getApiUrl('/api/fortune-result'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ result: label }),
        })
      } catch (e) {
        console.error('fortune result send error', e)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "../styles/_variables.scss";

.page_fortune {
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 16px 64px;
  display: flex;
  justify-content: center;

  &__inner {
    width: 100%;
    text-align: center;
  }

  &__title {
    font-size: 32px;
    line-height: 1.2;
    margin-bottom: 16px;
  }

  &__subtitle {
    max-width: 640px;
    margin: 0 auto 8px;
    font-size: 15px;
    line-height: 1.5;
    color: #9ca3af;

    &-bold {
      display: inline-block;
      margin-top: 15px;
      font-weight: 600;
    }
  }

  &__card {
    margin: 32px auto 0;
    max-width: 640px;
    background: #ffffff;
    border-radius: 24px;
    padding: 24px 24px 28px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.06);
  }

  &__wheel-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  &__already {
    margin: 32px auto 0;
    max-width: 420px;
    padding: 32px 28px 28px;
    background: linear-gradient(145deg, #0f172a 0%, #1e293b 100%);
    border-radius: 24px;
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.06);
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #f97316, #fb923c, #fbbf24);
    }
  }

  &__already-logo {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__already-logo-img {
    height: 56px;
    width: auto;
    object-fit: contain;
    filter: brightness(1.05);
  }

  &__already-text {
    margin: 0 0 8px;
    font-size: 15px;
    color: #94a3b8;
    line-height: 1.4;
  }

  &__already-value {
    margin: 0 0 12px;
    font-size: 28px;
    font-weight: 800;
    color: #fbbf24;
    letter-spacing: 0.02em;
    text-shadow: 0 0 20px rgba(251, 191, 36, 0.3);
  }

  &__already-hint {
    margin: 0;
    font-size: 13px;
    color: #64748b;
    line-height: 1.4;
  }
}
</style>

